/**
 * El mini-cart (bundle) hace dispatch de `custom::cart-updated` tras actualizar;
 * la cart page con `hh-inline-cart` hace reRender vía `updateQuantity` pero NO dispara
 * ese evento, así que Select2 nunca se reinicializa. Interceptamos fetch solo en
 * endpoints de carrito que devuelven `sections` y, tras el re-render, disparamos el
 * evento (setTimeout 0 = macrotask posterior a microtareas, p. ej. reRender en memoria).
 */
(function patchFetchForCartSectionReinit() {
  if (window.__spCartSectionsFetchPatched) return
  window.__spCartSectionsFetchPatched = true
  const _fetch = window.fetch
  const cartSectionUrl = /\/cart\/(change|update|add)/
  function requestUrl(input) {
    if (typeof input === 'string') return input
    if (input && typeof input === 'object' && input.url) return String(input.url)
    return ''
  }
  window.fetch = function () {
    return _fetch.apply(this, arguments).then(function (res) {
      if (!res || !res.ok) return res
      const url = requestUrl(arguments[0])
      if (!url || !cartSectionUrl.test(url)) return res
      const clone = res.clone()
      clone
        .json()
        .then(function (data) {
          if (data && data.sections && Object.keys(data.sections).length) {
            setTimeout(function () {
              window.dispatchEvent(new CustomEvent('custom::cart-updated'))
            }, 0)
          }
        })
        .catch(function () {})
      return res
    })
  }
})()

/**
 * The race condition issue (multiple re-renders in quick succession) only affects the cart page
 * (inline cart + checkAvailableFreeGift). In the mini-cart, a single re-render is typical;
 * immediate reinitialization without debounce is maintained there.
 */
function isCartPage() {
  return document.body && document.body.classList.contains('template-cart')
}

const STYLE_CART_DEBOUNCE_MS = 600
let _styleCartDebounceTimer = null
function scheduleStyleCartSelectors() {
  if (_styleCartDebounceTimer != null) {
    clearTimeout(_styleCartDebounceTimer)
  }
  _styleCartDebounceTimer = setTimeout(function () {
    _styleCartDebounceTimer = null
    styleCartSelectors()
  }, STYLE_CART_DEBOUNCE_MS)
}

function reinitSubscriptionSelectorsFromCartEvent() {
  if (isCartPage()) {
    scheduleStyleCartSelectors()
  } else {
    styleCartSelectors()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  styleCartSelectors()
})

window.addEventListener('custom::cart-updated', reinitSubscriptionSelectorsFromCartEvent)

/**
 * Select2 must attach the dropdown to an ancestor; mini-cart and cart page use
 * .mini-cart__body and .cart__body respectively.
 */

function getSubscriptionDropdownParent($select) {
  const $c = $select.closest('.mini-cart__body, .cart__body')
  return $c.length ? $c : $(document.body)
}

function styleCartSelectors() {
  setTimeout(() => { //Needed because was not working on quantity change

    let cartItems = document.querySelectorAll('.js-cart-item')

    if (!!!cartItems) return;

    cartItems.forEach((cartItem, index) => {


      let subscriptionSelector = $(cartItem).find(`[name="cart-item__subscription-select-${cartItem.dataset.itemid}-${cartItem.dataset.sellingplan}"]`);

      if (!subscriptionSelector.length) {
        return
      }

      subscriptionSelector.off('change');
      if (subscriptionSelector.data('select2') || subscriptionSelector.hasClass('select2-hidden-accessible')) {
        subscriptionSelector.select2('destroy')
      }

      subscriptionSelector.select2({
        dropdownParent: getSubscriptionDropdownParent(subscriptionSelector)
      });

      // Accessibility fixes for Select2 (WCAG 2.1 AA)
      fixCartSelect2Accessibility(cartItem, subscriptionSelector);

      subscriptionSelector.on('change', function () {
        updateSellingPlan(
          this.value,
          index + 1,
          cartItem.querySelector('hh-quantity-input')?._value,
          cartItem
        );
      });

    })

  }, 1);
}

async function updateSellingPlan(sellingPlanId, itemIndex, itemQuantity, cartItem) {
  const mini = document.querySelector('hh-mini-cart');
  const inline = document.querySelector('hh-inline-cart');
  const useInline = cartItem && cartItem.closest && cartItem.closest('hh-inline-cart');

  try {
    if (useInline) {
      if (inline) inline.loading = true;
    } else {
      if (mini) mini.loading = true;
    }

    let payload = {
      'line': itemIndex,
      'quantity': itemQuantity,
      'selling_plan': sellingPlanId,
      'properties': { '_purchase_type': sellingPlanId ? 'subscription' : 'one-time' }
    }

    let sections = "mini-cart,header,cart-notification,main-cart"

    let res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sections,
        ...payload
      })
    })

    let response = await res.json()

    reRenderShopifySections(response)
    if (useInline) {
      scheduleStyleCartSelectors()
    } else {
      styleCartSelectors()
    }

  } catch (error) {

    console.log(error);

  } finally {

    if (useInline) {
      if (inline) inline.loading = false;
    } else {
      if (mini) mini.loading = false;
    }

  }


}

function reRenderShopifySections(response, selector = "[data-rerender]") {

  return Object.keys(response.sections).forEach((key) => {
    const updatedNode = new DOMParser().parseFromString(response.sections[key], "text/html").querySelectorAll(selector);

    document.querySelector(`[id^="shopify-section-"][id*="${key}"]`)?.querySelectorAll(selector).forEach((node, index) => {
      if (updatedNode[index]) node.replaceWith(updatedNode[index]);
    });
  });
};

function fixCartSelect2Accessibility(cartItem, $selector) {
  const combobox = cartItem.querySelector('[role="combobox"]');
  if (!combobox) return;

  applyCartAriaFixes(cartItem);

  const observer = new MutationObserver(function () {
    applyCartAriaFixes(cartItem);
  });
  observer.observe(cartItem, { attributes: true, subtree: true, attributeFilter: ['aria-controls', 'role'] });

  combobox.addEventListener('keydown', function (e) {
    const isOpen = combobox.getAttribute('aria-expanded') === 'true';

    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowUp': {
        e.preventDefault();
        if (!isOpen) {
          $selector.select2('open');
          setTimeout(function () { highlightCartOption(cartItem, e.key === 'ArrowDown' ? 'first' : 'last'); }, 50);
        } else {
          highlightCartOption(cartItem, e.key === 'ArrowDown' ? 'next' : 'prev');
        }
        break;
      }
      case 'Enter': {
        if (isOpen) {
          e.preventDefault();
          var highlighted = cartItem.querySelector('[data-a11y-highlight="true"]');
          if (highlighted) {
            highlighted.removeAttribute('data-a11y-highlight');
            highlighted.click();
          }
        }
        break;
      }
      case 'Escape': {
        if (isOpen) {
          e.preventDefault();
          cartItem.querySelectorAll('[data-a11y-highlight]').forEach(function (el) { el.removeAttribute('data-a11y-highlight'); });
          $selector.select2('close');
        }
        break;
      }
    }
  });
}

function applyCartAriaFixes(cartItem) {
  const combobox = cartItem.querySelector('[role="combobox"]');
  const listbox = cartItem.querySelector('[role="listbox"]');

  if (combobox && listbox && listbox.id) {
    combobox.setAttribute('aria-controls', listbox.id);
  }

  const renderedSpan = cartItem.querySelector('.select2-selection__rendered[role="textbox"]');
  if (renderedSpan) {
    renderedSpan.removeAttribute('role');
    renderedSpan.removeAttribute('aria-readonly');
  }
}

function highlightCartOption(cartItem, direction) {
  const options = Array.from(cartItem.querySelectorAll('.select2-results__option--selectable'));
  if (!options.length) return;

  const current = cartItem.querySelector('[data-a11y-highlight="true"]');
  let currentIndex = current ? options.indexOf(current) : -1;

  options.forEach(function (opt) {
    opt.removeAttribute('data-a11y-highlight');
    opt.classList.remove('select2-results__option--highlighted');
  });

  var nextIndex;
  switch (direction) {
    case 'first': nextIndex = 0; break;
    case 'last':  nextIndex = options.length - 1; break;
    case 'next':  nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0; break;
    case 'prev':  nextIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1; break;
  }

  options[nextIndex].setAttribute('data-a11y-highlight', 'true');
  options[nextIndex].classList.add('select2-results__option--highlighted');
  options[nextIndex].scrollIntoView({ block: 'nearest' });

  const combobox = cartItem.querySelector('[role="combobox"]');
  if (combobox && options[nextIndex].id) {
    combobox.setAttribute('aria-activedescendant', options[nextIndex].id);
  }
}
